"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagAZ = function FlagAZ(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193,56.91H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06H-185.94A7.06,7.06,0,0,1-193,139.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94-122H209.54a7.06,7.06,0,0,1,7.06,7.06v82.39H-193v-82.39a7.06,7.06,0,0,1,7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#82afff"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.45",
    width: "409.6",
    height: "89.44",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.43,41.46a28.72,28.72,0,0,1,0-57.43A28.15,28.15,0,0,1,37.3-11.09a.69.69,0,0,0,.9-1.05,35.6,35.6,0,0,0-27-11,36,36,0,0,0-34.53,33.5A35.87,35.87,0,0,0,12.46,48.63a35.64,35.64,0,0,0,25.77-11,.7.7,0,0,0-.91-1,28.15,28.15,0,0,1-15.89,4.89Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M46.56-4.93l3,8.37,8-3.81a.71.71,0,0,1,1,.94l-3.82,8,8.37,3a.71.71,0,0,1,0,1.34l-8.37,3,3.82,8a.72.72,0,0,1-1,.95l-8-3.82-3,8.37a.71.71,0,0,1-1.34,0l-3-8.37-8,3.82a.71.71,0,0,1-.94-.95l3.81-8-8.37-3a.71.71,0,0,1,0-1.34l8.37-3-3.81-8a.7.7,0,0,1,.94-.94l8,3.81,3-8.37a.71.71,0,0,1,1.34,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagAZ;
exports["default"] = _default;